module.exports = __webpack_public_path__ + "img/p16_1.4fdb4641.png";